// extracted by mini-css-extract-plugin
module.exports = {"input":"CardTally_input__Nbc4t","section":"CardTally_section__pDS1h"};